/* c8 ignore start */
import { i18n } from "@/i18n.js";
import { SIDENAV_GROUP_BY } from "@/constants";
import { SAT_SERVICE } from "@/utils/services";
import { buildOrgUrl } from "@/utils/navigation/orgUrl";

const MSP_NAV_ITEMS = [
  {
    order: 4,
    groupBy: SIDENAV_GROUP_BY.EPSILON,
    label: i18n.global.t("report-manager"),
    icon: "cb-icon-report-manager",
    id: buildOrgUrl("msp", null, "report_manager"),
    dataTestId: "msp-report_manager",
    solutionId: SAT_SERVICE,
    permanentPill: {
      variant: "info",
      text: i18n.global.t("new"),
    },
    children: [],
  },
];

const CUSTOMER_NAV_ITEMS = [
  {
    order: 4,
    groupBy: SIDENAV_GROUP_BY.EPSILON,
    label: i18n.global.t("report-manager"),
    icon: "cb-icon-report-manager",
    id: buildOrgUrl("customer", null, "report_manager"),
    dataTestId: "customer-report_manager",
    solutionId: SAT_SERVICE,
    permanentPill: {
      variant: "info",
      text: i18n.global.t("new"),
    },
    children: [],
  },
];

export { MSP_NAV_ITEMS, CUSTOMER_NAV_ITEMS };
/* c8 ignore end */
